export default {
  filters(state) {
    return state.filters;
  },
  dialog_loading(state) {
    return state.dialog_loading;
  },
  loading(state) {
    return state.loading;
  },
  pagination(state) {
    return state.pagination;
  },
  loadingBillings(state) {
    return state.loadingBillings;
  },
  getItems(state) {
    return state.items;
  },
  getUpload(state) {
    return state.upload;
  },
};
